import { render, staticRenderFns } from "./TabsDefault.vue?vue&type=template&id=2a57858a"
import script from "./TabsDefault.vue?vue&type=script&lang=ts"
export * from "./TabsDefault.vue?vue&type=script&lang=ts"
import style0 from "./TabsDefault.vue?vue&type=style&index=0&id=2a57858a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports